import { AxiosError } from 'axios'

export const NETWORK_ERROR_MESSAGE = 'Network Error'

export const isServerError = (err: AxiosError) => {
  return (
    err.message === NETWORK_ERROR_MESSAGE ||
    (err?.response?.status &&
      err?.response?.status >= 500 &&
      err.response?.status < 600)
  )
}

export const isClientError = (err: AxiosError) => {
  return (
    err?.response?.status &&
    err.response?.status >= 400 &&
    err.response?.status < 500
  )
}

export class WrongUserTypeError {
  code: string
  name: string
  message: string
  constructor() {
    this.code = 'NotAuthorizedException'
    this.name = 'NotAuthorizedException'
    this.message = 'Wrong user type'
  }
}
